import { TruckIcon as Truck, CreditCardIcon as CreditCard, HeadphonesIcon as Headphones } from "@/components/icons/HeaderIcons";

const usps = [
  { icon: Truck, text: "Snabb leverans 1–3 dagar" },
  { icon: CreditCard, text: "Säker betalning med Klarna & Swish" },
  { icon: Headphones, text: "Hjälp av riktiga djurälskare" },
];

const USPBar = () => (
  <section className="border-b border-border/60 py-3.5 bg-primary-50/50">
    <div className="container px-4 md:px-6">
      <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2">
        {usps.map((usp, i) => (
          <div key={i} className="flex items-center gap-2">
            <usp.icon className="h-4 w-4 text-primary shrink-0" strokeWidth={2} />
            <span className="text-xs md:text-sm font-medium text-foreground/80">
              {usp.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default USPBar;
